import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// import { AppState } from '@capacitor/app';
import { failedTransaction, setLoadingSpinner } from '../actions/shared.action';
import { catchError, exhaustMap, filter, map, mergeMap, of, tap } from 'rxjs';
import { ROUTER_NAVIGATION, RouterNavigatedAction } from '@ngrx/router-store';
import * as fromAccountActions from '../actions/account.action'
import { APIResponse } from 'src/app/models/api-response.model';
import { AccountService } from 'src/app/services/account.service';
import { Router } from '@angular/router';

@Injectable()
export class SharedEffects {
  failedTransaction$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(failedTransaction),
        tap((action) => {
          if(action?.data?.message == 'Unauthenticated.'){
            this.router.navigateByUrl('/landing');
          }
          console.log('failedTransaction$', action.data);
        })
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private accountService: AccountService,
    private router: Router
    // private store: Store<AppState>,
  ) {}

}
